export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70faed24471c2fe23c116f4e65e5e168d3b3b9cd4f&name=pushAdClickData!'